// Unpublished Work © 2022 Deere & Company

export const adaptLocaleUnderscoreToDash = (locale) => locale.replace('_', '-');

export const adaptLocaleDashToUnderscore = (locale) => locale.replace('-', '_');
